import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RxListCompositeComponent, RxTextCompositeComponent } from '@nrwl/rx-forms';
import { Playlist } from '@nrwl/rx-models';

import { DialogsConfigService } from '../dialogs-config.service';

@Injectable({
  providedIn: 'root',
})
export class AppleTVManagementDialogConfigService extends DialogsConfigService {
  constructor() {
    super();
  }

  public deselectAllConfirmation() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: '[TODO Message]: Do you want to deselect all items?',
        tip: '[TODO Description]: Explanatory message',
        buttons: this.SubmitDismissButtons('Yes', 'No'),
      },
    };
  }

  public confirmResetChanges() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirm changes',
        tip: 'Unsaved changes may be lost',
        buttons: this.SubmitDismissButtons('Proceed', 'Cancel'),
      },
    };
  }

  public selectedInfo() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'You can not select items from both libraries',
        buttons: this.DismissButton(),
      },
    };
  }

  public selectedCategory() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Alert',
        tip: 'Items(s) selected in this group will be deselected by this action',
        buttons: this.SubmitDismissButtons('Proceed', 'Cancel'),
      },
    };
  }

  public addPlaylist() {
    return {
      payload: {
        title: 'Add AppleTV Playlist',
        data: new Playlist(),
        buttons: this.SubmitDismissButtons('Save', 'Cancel'),
      },
    };
  }

  public editPlaylist(playlist: Playlist = new Playlist()) {
    return {
      payload: {
        title: 'Edit AppleTV Playlist',
        data: playlist,
        buttons: this.SubmitDismissButtons('Save', 'Cancel'),
      },
    };
  }

  public confirmRemovingPlaylistItems() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirmation required',
        tip: 'Are you sure you want to remove the item(s)?',
        buttons: this.SubmitDismissButtons('Delete'),
      },
    };
  }

  public confirmRemovePlaylist() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirmation required',
        tip: 'Are you sure you want to remove the playlist?',
        buttons: this.SubmitDismissButtons('Delete'),
      },
    };
  }

  public clonePlaylistItems(items$: Observable<Playlist[]>) {
    return {
      component: RxListCompositeComponent,
      payload: {
        title: 'Clone to',
        items$: items$,
        buttons: this.SubmitDismissButtons('Clone'),
      },
    };
  }

  public movetoPlaylistItems(items$: Observable<Playlist[]>) {
    return {
      component: RxListCompositeComponent,
      payload: {
        title: 'Move to',
        items$: items$,
        buttons: this.SubmitDismissButtons('Move'),
      },
    };
  }

  public addPlaylistItems(items$: Observable<Playlist[]>) {
    return {
      component: RxListCompositeComponent,
      payload: {
        title: 'Add to',
        items$: items$,
        buttons: this.SubmitDismissButtons('Add'),
      },
    };
  }

  public confirmLeavingPage() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirm Navigation',
        tip: 'You have unsaved changes. Are you sure you want to leave this page?',
        buttons: this.SubmitDismissButtons('Leave this Page', 'Stay on this Page'),
      },
    };
  }
}
